import type { GeolocationChangeType } from './types';
import type { IToastConfig } from 'src/common/primitives/Toast';

export function generateGeolocationToast(
  id: number,
  changeType: GeolocationChangeType
): IToastConfig {
  const actionDescription = getActionDescription(changeType);
  return {
    id,
    title: `Success`,
    description: `The geolocation has been ${actionDescription}.`,
    type: 'success',
  };
}

function getActionDescription(changeType: GeolocationChangeType): string {
  switch (changeType) {
    case 'create':
      return 'created';
    case 'archive':
      return 'archived';
    case 'unarchive':
      return 'unarchived';
    case 'update':
    default:
      return 'updated';
  }
}
